import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminConfiguracionesPage } from "@/features/admin-configuraciones/components/AdminConfiguracionesPage";
import { configuracionesAdminQueryOptions } from "@/features/admin-configuraciones/hooks/use-configuraciones-admin";

/**
 * Ruta `/admin/configuraciones` · gestor de ajustes de la app (tabla
 * administracion.configuraciones).
 */
export const Route = createFileRoute("/_authed-tw/admin/configuraciones")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(configuracionesAdminQueryOptions),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminConfiguraciones]}>
      <AdminConfiguracionesPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
